"use strict";

exports.buffer = Symbol("buffer");
exports.type = Symbol("type");
exports.lastModified = Symbol("lastModified");
exports.closed = Symbol("closed");




//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/blob-symbols.js
// module id = Hvo4
// module chunks = 1